import * as React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';
import { alpha, styled } from '@mui/material/styles';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';

function MinusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
        </SvgIcon>
    );
}

function PlusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
        </SvgIcon>
    );
}

function CloseSquare(props) {
    return (
        <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
        </SvgIcon>
    );
}

const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
    padding: 3,
    color: '#000000',
    [`& .${treeItemClasses.iconContainer}`]: {
        '& .close': {
            opacity: 0.3
        }
    },
    [`& .${treeItemClasses.groupTransition}`]: {
        marginLeft: 10,
        paddingLeft: 18,
        padding: 3,
        borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`
    }
}));
const ParentNode = ({ data }) => {
    return (
        <>
            {data.org === true ? (
                <CustomTreeItem itemId="0" label={`${data.name} (Organization)`} key="0" sx={{ fontSize: '18px' }}>
                    {data.droppable === true && data.children.map((child) => <ChildNode key={child.id} data={child} />)}
                </CustomTreeItem>
            ) : (
                <CustomTreeItem itemId={data.id.toString()} label={data.name} key={data.id}>
                    {data.droppable === true && data.children.map((child) => <ChildNode key={child.id} data={child} />)}
                </CustomTreeItem>
            )}
        </>
    );
};

ParentNode.propTypes = {
    data: PropTypes.object
};

const ChildNode = ({ data }) => {
    return (
        <CustomTreeItem itemId={data.id.toString()} label={data.name} key={data.id} sx={{ fontSize: '18px' }}>
            {data.droppable === true && data.children && data.children.map((child) => <ChildNode key={child.id} data={child} />)}
        </CustomTreeItem>
    );
};

ChildNode.propTypes = {
    data: PropTypes.object
};

const GroupsTreeView = ({ groupsData, handleFilterGroups }) => {
    const handleFilterValue = (e, nodeId, isSelected) => {
        if (isSelected) {
            e.stopPropagation();
            handleFilterGroups(nodeId);
        }
    };
    return (
        <SimpleTreeView
            aria-label="customized"
            defaultExpandedItems={['0']}
            onItemSelectionToggle={handleFilterValue}
            slots={{
                expandIcon: PlusSquare,
                collapseIcon: MinusSquare,
                endIcon: CloseSquare
            }}
            sx={{
                height: '100%',
                flexGrow: 1,
                overflowY: 'auto',
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                fontSize: '12px'
            }}
        >
            {groupsData['results']?.map((data) => (
                <ParentNode data={data} key={data.id} />
            ))}
        </SimpleTreeView>
    );
};

GroupsTreeView.propTypes = {
    groupsData: PropTypes.object,
    handleFilterGroups: PropTypes.func
};

export default GroupsTreeView;
